import React from 'react';
import ReactDOM from 'react-dom';
import router from './router';

document.addEventListener( 'DOMContentLoaded', () => {
	ReactDOM.render( router, document.getElementById( 'app' ) );
}, false );



/** WEBPACK FOOTER **
 ** ./app/index.js
 **/